export default __webpack_public_path__ + "images/pdf_logo_2a6da06007eeadcb3720cafbb8c274c4.png";